import { VisibilityCondition } from './conditions/visibility-condition';
import { VisibilityMode } from './visibility-mode';

export class VisibilityCriteria {
    visibilityMode: VisibilityMode;
    conditions: VisibilityCondition[];
}
